<template>
    <PageFull header="Все счета" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full p-0">                
                <AccountList v-if="accounts" :accounts="accounts" :total="totalRecords" :loading="loading"
                    @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams" />
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import PageFull from '@/components/public/page.vue'
import AccountList from '@/components/admin/account/list.vue'

export default {
    data() {
        return {
            accounts: null,
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
        }
    },
    components: {
        PageFull,
        AccountList
    },
    methods: {
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadLazyData();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadLazyData()
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 50
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const filter = (this.lazyParams.filters) ? this.lazyParams.filters : {}
            const sort = (this.lazyParams.sort) ? this.lazyParams.sort : null

            const accounts = await this.connect.GetAdminAccountList(limit, skip, filter, sort).then(res => res)
            if (accounts.result && accounts.data) {
                if(accounts.data.list && accounts.data.list.length > 0) {
                    this.accounts = accounts.data.list
                    this.totalRecords = accounts.data.total
                } else {
                    this.accounts = []
                    this.totalRecords = 0
                }
            } else {
                this.accounts = []
                this.totalRecords = 0
                if (accounts.errors && accounts.errors.length > 0) {
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: accounts.errors[0], life: 3000 });
                }
            }
            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.lazyParams.filters = this.filters
        this.loadLazyData()
    },
}
</script>